import { RouteObject } from 'react-router-dom'

import LayoutPage from 'features/layout/pages/LayoutPage'
import AuthenticatedRoute from 'providers/router/components/AuthenticatedRoute'
import AuthorizedRoute from 'providers/router/components/AuthorizedRoute'
import RootRedirection from 'providers/router/components/RootRedirection'
import RouterErrorPage from 'providers/router/components/RouterErrorPage'
import { abTestsRoutes } from './abTestsRoutes'
import { financeRoutes } from './financeRoutes'
import { globalSetupRoutes } from './globalSetupRoutes'
import { historyRoutes } from './historyRoutes'
import { inventoryRoutes } from './inventoryRoutes'
import { performanceRoutes } from './performanceRoutes'
import { portalRoutes } from './portalRoutes'
import { productRoutes } from './productRoutes'
import { ROUTES } from './routePaths'
import { tagRoutes } from './tagRoutes'
import { userRoutes } from './userRoutes'
import { workspaceRoutes } from './workspaceRoutes'

export const protectedRoutes: RouteObject[] = [
  {
    children: [
      {
        children: [
          {
            element: <RootRedirection />,
            path: ROUTES.BASE.ROOT,
          },
          ...abTestsRoutes,
          ...financeRoutes,
          ...globalSetupRoutes,
          ...historyRoutes,
          ...inventoryRoutes,
          ...performanceRoutes,
          ...portalRoutes,
          ...productRoutes,
          ...tagRoutes,
          ...userRoutes,
          ...workspaceRoutes,
        ],
        element: (
          <AuthorizedRoute
            access='Layout'
            page={<LayoutPage />}
          />
        ),

        path: ROUTES.BASE.ROOT,
      },
    ],
    element: <AuthenticatedRoute />,
    errorElement: <RouterErrorPage />,

    path: ROUTES.BASE.ROOT,
  },
]
